import {
  ActiveOrderGroup,
  ActiveOrderPaymentStatus,
} from "view/components/ShoppingSummary/context";
import { red } from "@material-ui/core/colors";

const DEFAULT_BORDER = "1px solid transparent";

export const getProductListBorder = (
  activeGroup: ActiveOrderGroup | null,
  ownerId: string,
  primaryColor: string
) => {
  if (!activeGroup) {
    return DEFAULT_BORDER;
  }
  const { supplierId, paymentStatus } = activeGroup;
  if (supplierId !== ownerId) {
    return DEFAULT_BORDER;
  }
  const color =
    paymentStatus === ActiveOrderPaymentStatus.Error ? red[500] : primaryColor;
  return `1px solid ${color}`;
};
